import PropTypes from 'prop-types';
import './FormControls.css';

function CheckBox({
  label,
  handleChange = () => {},
  checked,
  name,
  mt,
  disabled,
  style = {},
}) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginTop: mt,
        ...style,
      }}
    >
      <label className="lbl">
        <input
          className="inp"
          name={name}
          type="checkbox"
          onChange={handleChange}
          checked={checked || false}
          disabled={disabled}
        />
        <span className="checkbox" />
      </label>
      <label
        className="label"
        style={{
          cursor: 'pointer',
          marginLeft: '8px',
          marginTop: '4px',
          height: '24px',
        }}
      >
        {label}
      </label>
    </div>
  );
}

export default CheckBox;

CheckBox.propTypes = {
  // label: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  checked: PropTypes.bool,
  name: PropTypes.string,
};
